<template>
  <q-card class="glasscard" elevation="2">
    <q-card-section v-if="caption" class="row justify-between items-center q-py-sm" :class="color">
      <div class="text-h6 q-mb-none"><q-icon v-if="icon" size="sm" :name="icon" class="q-mr-md"></q-icon> {{ caption }}</div>
      <slot name="top-right"></slot>
    </q-card-section>
    <q-card-section>
      <slot></slot>
    </q-card-section>
  </q-card>
</template>

<script setup>
defineProps({
  color: { type: String, default: "secondary" },
  caption: { type: String },
  icon: { type: String },
});
</script>

<style lang="scss">
.has-background .q-card.glasscard {
  backdrop-filter: blur(12px) saturate(180%);
  -webkit-backdrop-filter: blur(12px) saturate(180%);
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.9);
}

.body--dark .has-background .q-card.glasscard {
  background-color: rgba(38, 50, 56, 0.75);
}

.glasscard {
  .v-label {
    font-size: 0.8rem;
  }

  body.screen--xs & .q-card__section--vert {
    padding: 15px 5px;
  }
}
</style>
